import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetExportAgentCommission } from "../../../api/contract/service"
import { callExportAgentCommission } from "../../../api/export"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import { FormatCurrencys } from "../../../utils/commonUtil"
import moment from "moment";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SmartTable from "../../../components/common/table-component";

const Index = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', reportType: 0, reportValue: "north" });
	const [agentCommission, setAgentCommission] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);

	useEffect(() => {
		loadData();

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, fromDate: fromDate, toDate: toDate };
		const rsp = await dispatch(callGetExportAgentCommission(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setAgentCommission(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const downloadExcel = async () => {
		try {
			let data = { page: request.page, maxResult: totalRecord, keyword: request.keyword, fromDate: fromDate, toDate: toDate };
			let response = await callExportAgentCommission(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text329", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
			Swal.fire(__t("uiText.text023"), "Error downloading excel" + error, "error");
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("report.agentCommision.name")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={fromDate}
														onChange={date => setFromDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={toDate}
														onChange={date => setToDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>

												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "report.agentCommision.content.agentCode", key: "agentCode", style: { minWidth: '100px' } },
							{ labelKey: "report.agentCommision.content.firstName", key: "firstName", style: { minWidth: '150px' } },
							{ labelKey: "report.agentCommision.content.lastName", key: "lastName", style: { minWidth: '150px' } },
							{ labelKey: "report.agentCommision.content.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('payments.status.paid')}</span> : <span className="badge bg-danger">{t('payments.status.notyet')}</span> },
							{ labelKey: "report.agentCommision.content.totalReceiveCommission", key: "totalReceiveCommission", style: { minWidth: '150px' }, render: (val) => FormatCurrencys(val) },
							{ labelKey: "report.agentCommision.content.months", key: "months" },
							{ labelKey: "report.agentCommision.content.insuranceType", key: "insuranceTypeName", render: (val) => val == "vehicle_insurance" ? t("report.agentCommision.content.vehicle_insurance") : t("report.agentCommision.content.life_insurance") },
						]}
	data={{ result: agentCommission }}
	rowKey="id"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={true}
	rowNumberOffset={(request.page - 1) * request.maxResult}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
